import membership       from '../pages/membership/membership/MembershipPage.vue'
// import registMember from '../pages/membership/regist-member/MemberRegister.vue'
// import individualForm from '../pages/membership/individual-form/IndividualMembershipForm.vue'
// import corporateForm from '../pages/membership/corporate-form/CorporateMembershipForm.vue'
import membershipmain from '../pages/membership/membership-main/MembershipMain.vue'
import membershipjoin from '../pages/membership/membership-join/MembershipJoin.vue'

export default [
    {
        path: '/membership',
        name: 'membership',
        component: membership,
    },
    // {
    //     path: '/regist-member',
    //     name: 'regist-member',
    //     component: registMember,
    // },
    // {
    //     path: '/individual-form',
    //     name: 'individual-form',
    //     component: individualForm,
    // },
    // {
    //     path: '/corporate-form',
    //     name: 'corporate-form',
    //     component: corporateForm,
    // },
    {
        path: '/membershipmain',
        name: 'membershipmain',
        component: membershipmain,
    },
    {
        path: '/membershipjoin',
        name: 'membershipjoin',
        component: membershipjoin,
    },


]
